// angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// material
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ModalLayoutModule } from '@app/components/modals/base/modal-layout/modal-layout.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { HttpClientModule } from '@angular/common/http';
import { SupportSnackBarComponent } from './snack-bar/support-snack-bar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// app.component
import { SpinnerModule } from './../shared/spinner/spinner.module';
import { SupportModalComponent, SuccessSupportModalComponent } from '.';
import { MainLogoModule } from '@app/infrastructure/components/main-logo/main-logo.module';

@NgModule({
	declarations: [SupportModalComponent, SuccessSupportModalComponent, SupportSnackBarComponent],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		ModalLayoutModule,
		MatSnackBarModule,
		MatIconModule,
		MatProgressSpinnerModule,
		SpinnerModule,
		MainLogoModule,
	],
})
export class SupportRequestModule {}
